import { request, requestWithMeta } from './client.js'

export interface Participant {
  readonly id: string
  readonly registrationNo: string
  readonly fullName: string
  readonly birthPlace: string | null
  readonly birthDate: string | null
  readonly institution: { readonly code: string; readonly name: string } | null
}

export interface ImportReport {
  readonly created: number
  readonly failed: number
  readonly errors: readonly { row: number; field: string; message: string }[]
}

export async function listParticipants(
  page: number,
  q: string,
): Promise<{ rows: readonly Participant[]; total: number }> {
  const params = new URLSearchParams({ page: String(page), limit: '25' })
  if (q !== '') params.set('q', q)
  const { data, total } = await requestWithMeta<readonly Participant[]>(`/api/v1/peserta?${params}`)
  return { rows: data, total }
}

export async function createParticipant(input: {
  registrationNo: string
  fullName: string
  birthPlace?: string
  birthDate?: string
}): Promise<Participant> {
  return request<Participant>('/api/v1/peserta', { method: 'POST', body: input })
}

export async function importParticipantsCsv(csv: string): Promise<ImportReport> {
  return request<ImportReport>('/api/v1/peserta/import', { method: 'POST', body: { csv } })
}
